export const cleanParams = (obj) => {
  return Object?.fromEntries(
    Object?.entries(obj)
      ?.filter(([_, value]) => {
        if (value === undefined || value === null || value === "") return false;

        if (Array?.isArray(value)) {
          const filteredArray = value?.filter(
            (v) => v !== undefined && v !== null && v !== ""
          );
          return filteredArray?.length > 0;
        }

        return true;
      })
      ?.map(([key, value]) => {
        if (Array?.isArray(value)) {
          const filteredArray = value?.filter(
            (v) => v !== undefined && v !== null && v !== ""
          );
          return [key, filteredArray];
        }
        return [key, value];
      })
  );
};

export const allowOnlyEmptyString = (obj) => {
  return Object?.fromEntries(
    Object?.entries(obj)
      ?.filter(([_, value]) => {
        if (value === undefined || value === null) return false;

        if (Array?.isArray(value)) {
          const filteredArray = value?.filter(
            (v) => v !== undefined && v !== null
          );
          return filteredArray?.length > 0;
        }

        return true;
      })
      ?.map(([key, value]) => {
        if (Array?.isArray(value)) {
          const filteredArray = value?.filter(
            (v) => v !== undefined && v !== null && v !== ""
          );
          return [key, filteredArray];
        }
        return [key, value];
      })
  );
};

export const makeParamsListToString = (items: string[]) => {
  const encodedValue = String(items.join(","));
  return encodedValue;
};

export const encodeArrayObjects = (obj) => {
  return Object.fromEntries(
    Object.entries(obj)?.map(([key, value]) => {
      if (Array?.isArray(value)) {
        return [key, makeParamsListToString(value)];
      }
      return [key, value];
    })
  );
};

export const buildFetchTicketJobsUrl = ({
  endpoint,
  materialId,
  vendorId,
  companyId,
  jobId,
  orderId,
}) => {
  const params = new URLSearchParams();

  if (materialId) params.append("materialId", materialId);
  if (vendorId) params.append("vendorId", vendorId);
  if (companyId) params.append("companyId", companyId);
  if (jobId) params.append("jobId", jobId);
  if (orderId) params.append("orderId",orderId);

  return `${endpoint}?${params.toString()}`;
};
